module.exports = __webpack_public_path__ + "static/media/fbscan.486103f7.png";